import { render } from "./RegisterView.vue?vue&type=template&id=f562d842&ts=true"
import script from "./RegisterView.vue?vue&type=script&lang=ts"
export * from "./RegisterView.vue?vue&type=script&lang=ts"

import "./RegisterView.vue?vue&type=style&index=0&id=f562d842&lang=css"

import exportComponent from "E:\\Github\\guardsonlinesms\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__